import { render, staticRenderFns } from "./PackageDetailInfo.vue?vue&type=template&id=4ebb2ec4&scoped=true&"
import script from "./PackageDetailInfo.vue?vue&type=script&lang=js&"
export * from "./PackageDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./PackageDetailInfo.vue?vue&type=style&index=0&id=4ebb2ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebb2ec4",
  null
  
)

export default component.exports